import classNames from 'classnames'
import {gsap} from 'gsap'
import * as React from 'react'

import ArrowLeft from '@/assets/specify/IconDoodleArrowLeft'
import ArrowRight from '@/assets/specify/IconDoodleArrowRight'
import FeaturesLeft from '@/assets/specify/IconDoodleFeaturesLeft'
import FeaturesRight from '@/assets/specify/IconDoodleFeaturesRight'
import UnderlineLeft from '@/assets/specify/IconDoodleUnderlineLeft'
import UnderlineRight from '@/assets/specify/IconDoodleUnderlineRight'
import {storyToLink} from '@/common/utils'
import Image from '@/components/Image'
import Link from '@/components/Link'

const formatDate = (date) => {
  if (date) {
    return new Date(date).toLocaleDateString(undefined, {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    })
  }
}

const backgroundColorsMap = gsap.utils.wrap([
  'bg-turquoise-400 text-white',
  'bg-yellow-400 text-violet-600',
  'bg-violet-400 text-yellow-400',
  'bg-violet-400 text-yellow-400',
  'bg-turquoise-400 text-white',
  'bg-yellow-400 text-violet-600',
])

const ressourcesBgColors = (bgCard) => {
  switch (bgCard) {
    case 'yellow':
      return 'bg-yellow-300 text-yellow-400'
    case 'violet':
      return 'bg-violet-300 text-violet-400'
    case 'blue':
      return 'bg-turquoise-300 text-violet-400'
    default:
      return 'bg-yellow-300 text-yellow-400'
  }
}
const doodlesShape = [
  'arrow_right',
  'features_right',
  'underline_right',
  'arrow_left',
  'features_left',
  'underline_left',
]

const Doodle = (props) => {
  switch (props.shape) {
    case 'arrow_right':
      return <ArrowRight />
    case 'arrow_left':
      return <ArrowLeft />
    case 'features_right':
      return <FeaturesRight />
    case 'features_left':
      return <FeaturesLeft />
    case 'underline_right':
      return <UnderlineRight />
    case 'underline_left':
      return <UnderlineLeft />
    default:
      return 'arrow_right'
  }
}

const Card = ({story, cardLabel, backgroundColor, index}) => {
  const {title, description, cover, category, date} = story.content || {}
  return (
    <li
      key={story.uuid}
      className={classNames(
        'group flex rounded-2xl p-4 lg:p-10',
        backgroundColor ? ressourcesBgColors(backgroundColor, index) : backgroundColorsMap(index)
      )}
    >
      <Link link={storyToLink(story)} className={'relative block w-full md:flex md:flex-col'}>
        <div className='aspect-w-15 aspect-h-10 relative'>
          <div className='overflow-hidden rounded-2xl'>
            <Image
              {...cover}
              className='rounded-2xl transition group-hover:scale-110'
              sizes={{md: 50, lg: 33}}
              ratio={'15:10'}
            />
          </div>
          <div className='absolute top-0 -left-10 hidden w-full scale-0 opacity-0 transition duration-200 group-hover:scale-100 group-hover:opacity-100 lg:block'>
            <Doodle shape={gsap.utils.random(doodlesShape)} />
          </div>
        </div>

        <div className='mt-8 flex flex-1 flex-col justify-between gap-8 text-purple-900'>
          <div>
            <p className='heading-xs-millik mb-1'>{title}</p>
            <div className='misc-button-s mb-1 flex items-center gap-4'>
              {!!category && (
                <p className='gap-4 rounded-full border border-purple-900 px-3 py-1'>
                  {category.name}
                </p>
              )}

              {(!!date || !!category) && <div>•</div>}

              {!!date && <p className='relative block'>{formatDate(date)}</p>}
            </div>
            <p className='body-s-regular line-clamp-3'>{description}</p>
          </div>

          <div className='misc-button-m rounded-full border border-purple-900 px-8 py-4 text-center transition-all duration-150 group-hover:bg-purple-900 group-hover:text-white'>
            {cardLabel}
          </div>
        </div>
      </Link>
    </li>
  )
}

export default Card
